import LayoutFull from '@/layouts/full/LayoutFull.vue'
import multiGuard from '@/router/utils/vue-router-multiguard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import authGuard from '@/router/guards/auth-guard'
import checkAddPageGuard from '@/router/guards/check-add-page-guard'
import checkPageFeaturesGuard from '@/router/guards/check-page-features-guard'
import PAGE_FEATURES from '@/constants/page-features'

export default [
  {
    path: '/bot',
    component: LayoutFull,
    beforeEnter: multiGuard([checkTokenGuard, authGuard, checkAddPageGuard, checkPageFeaturesGuard]),
    children: [
      {
        path: 'builder/:id?',
        name: 'owner:bot:flow',
        meta: { pageFeatures: [PAGE_FEATURES.BOT, PAGE_FEATURES.STORE] },
        component: () => import(/* webpackChunkName: "bot" */ '@/views/bot/BotBuilder.vue'),
      },
      {
        path: 'templates',
        name: 'owner:bot:templates',
        meta: { pageFeatures: [PAGE_FEATURES.BOT, PAGE_FEATURES.STORE] },
        component: () => import(/* webpackChunkName: "bot" */ '@/views/bot/BotFlowTemplatesTable.vue'),
      },
      {
        path: 'settings',
        name: 'owner:bot:settings',
        meta: { pageFeatures: [PAGE_FEATURES.BOT, PAGE_FEATURES.STORE] },
        component: () => import(/* webpackChunkName: "bot" */ '@/views/bot/BotManager.vue'),
      },
      {
        path: 'subscribers',
        name: 'owner:bot:subscribers',
        meta: { pageFeatures: [PAGE_FEATURES.BOT, PAGE_FEATURES.STORE] },
        component: () => import(/* webpackChunkName: "bot" */ '@/views/bot/SubscribersTable.vue'),
      },
      {
        path: 'fb/chat',
        name: 'owner:fb-chat',
        meta: {
          contentRenderer: 'sidebar-left',
          contentClass: 'chat-application',
          pageFeatures: [PAGE_FEATURES.BOT, PAGE_FEATURES.STORE],
        },
        component: () => import(/* webpackChunkName: "fb-chat" */ '@/views/chat/Chat.vue'),
      },
    ],
  },
]
